import { ChevronDown } from 'lucide-react';
import type { PersonaReviewItem } from '../types';

export function PersonaContext({ persona }: { persona: PersonaReviewItem }) {
  const rows = [
    { label: 'Scenario', value: persona.goal },
    { label: 'Motivations and concerns', value: persona.painPoints },
    { label: 'Persona notes', value: persona.constraints },
  ].filter((row) => row.value);

  if (rows.length === 0) return null;

  return (
    <details className="group rounded-md border border-border/80 bg-background px-3 py-2" open={rows.length <= 1}>
      <summary className="flex cursor-pointer list-none items-center justify-between gap-3 text-xs font-medium text-muted-foreground">
        <span className="inline-flex items-center gap-1.5">
          Persona context
        </span>
        <ChevronDown className="h-3.5 w-3.5 shrink-0 transition-transform group-open:rotate-180" />
      </summary>
      <div className="mt-2 divide-y divide-border/70">
        {rows.map((row) => (
          <div key={row.label} className="grid gap-2 py-2 first:pt-0 last:pb-0 sm:grid-cols-[150px_minmax(0,1fr)]">
            <p className="text-[11px] font-medium uppercase leading-5 text-muted-foreground">{row.label}</p>
            <p className="whitespace-pre-wrap text-sm leading-5 text-foreground">{row.value}</p>
          </div>
        ))}
      </div>
    </details>
  );
}
